import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export type UnsubscribeSchoolArgs = { materialId: number; isApproved?: boolean };

const unsubscribeSchool = ({ materialId, isApproved }: UnsubscribeSchoolArgs): Promise<void> => {
    const params: Record<string, string | boolean> = {
        subjectType: 'material',
        subjectId: String(materialId)
    };

    if (isApproved) {
        params.isApproved = true;
    }

    return axios.post(API_URLS.SUBSCRIPTION.UNFOLLOW_SCHOOL, params) as unknown as Promise<void>;
};

export default unsubscribeSchool;
